<script>
	import Datepicker from "vuejs-datepicker";
	import { ptBR } from "vuejs-datepicker/dist/locale";

	export default {
		name: "TitleMonth",
		components: {
			Datepicker
		},

		props: {
			options: {
				type: Object,
				required: false
			},
			color: {
				type: String,
				default: "black"
			},
			backColor: {
				type: String,
				default: "rgb(200, 198, 198, 1)"
			},
			cursor: {
				type: String,
				default: "default"
			},
			border: {
				type: String,
				default: "solid 1px rgb(200, 198, 198, 1)"
			},
			dateSearch: {
				type: Date,
				required: false
			},
			topAdjustment: {
				type: Number,
				required: false,
				default: 0
			},
			isMobile: {
				type: Boolean,
				required: true
			}
		},

		data () {
			return {
				monthAndYear: null,
				ptBR,
				showArrowBtn: "▼",
				datepickerShow: false,
				invalidForm: true
			};
		},

		watch: {
			monthAndYear () {
				const currentMonth = this.dateSearch.getMonth();
				const currentYear = this.dateSearch.getFullYear();
				const newMonth = this.monthAndYear.getMonth();
				const newYear = this.monthAndYear.getFullYear();

				this.invalidForm = Boolean(newMonth === currentMonth && newYear === currentYear);
			}
		},

		computed: {
			labelTitleStyle () {
				return {
					background: this.options.backColor || this.backColor,
					color: this.options.color || this.color,
					cursor: this.options.cursor || this.cursor,
					border: this.options.border || this.border
				};
			},

			datepickerStyle () {
				const screenTotalHeight = window.innerHeight;
				const rect = this.$refs.titleMonth.getBoundingClientRect();
				const top = String(parseInt(rect.top + rect.height + this.topAdjustment)).concat("px");
				const height = String(parseInt(screenTotalHeight - (rect.top + rect.height + this.topAdjustment))).concat("px");

				return {
					width: "100% !important",
					display: "flex",
					position: "fixed",
					left: "0px",
					top: `calc(${top} - 0.92rem)`,
					border: this.isMobile ? "none" : "none",
					"background-color": "transparent",
					"justify-content": "center !important",
					"align-items": "top !important",
					height: `calc(${height} - 0.9rem)`
				};
			}
		},

		methods: {
			clickTitleMonth () {
				if (!this.dateSearch) return;

				if (this.datepickerShow) {
					this.closeModal();
					return;
				}

				this.monthAndYear = new Date(this.dateSearch);
				this.datepickerShow = true;
				this.showArrowBtn = "▲";
			},

			formatter (date) {
				if (!date) return "";

				const month = String(date.getMonth() + 1).padStart(2, "0");
				const year = date.getFullYear();

				return `${month}/${year}`;
			},

			closeModal () {
				this.showArrowBtn = "▼";
				this.datepickerShow = false;
			},

			confirm () {
				this.$emit("changeDateSearch", { date: this.monthAndYear });
				this.closeModal();
			}
		}
	};


</script>

<template>
    <div
		class="tituloMes"
		:style="labelTitleStyle"
    >
		<div
			@click="clickTitleMonth()"
			style="cursor: pointer;"
			id="titleMonth"
			ref="titleMonth"
		>
			<span>{{ options.label }}</span>
			<b-button
				class="btn-select"
			>
				{{ showArrowBtn }}
			</b-button>
		</div>
		<div
			:style="datepickerStyle"
			v-if="dateSearch && datepickerShow"
		>
			<div class="modal-div">
				<div>
					<datepicker
						name="changeDateSearch"
						class="w-100"
						id="change-date-search"
						v-model="monthAndYear"
						:format="formatter"
						:inline="true"
						value-type="format"
						:minimum-view="'month'"
						:maximum-view="'year'"
						:language="ptBR"
					/>
				</div>
				<div class="mt-2 seccion-con-linea"/>
				<b-button class="ml-1 mt-2 float-left btn-modal btn-cancel btn-cancel-only" @click="closeModal()">Cancelar</b-button>
				<b-button
					class="mt-2 ml-1 float-right btn-modal btn-salvar"
					@click="confirm()"
					:disabled="invalidForm"
				>
					Confirmar
				</b-button>
			</div>
		</div>
    </div>
</template>

<style scoped>
    .btn-select {
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: transparent;
        color: black !important;
        border: none;

    }

    .btn-select:focus,
	.btn-select.focus,
	.btn-select.click,
	.btn-select:active,
	.btn-select.active {
        outline: none !important;
        box-shadow: none !important;
		background-color: transparent !important;
    }



	.seccion-con-linea {
		border-bottom: 1px solid rgb(102, 101, 101);
		padding-bottom: 10px;
		margin-bottom: 10px;
		width: calc(100% + 28px);
	}

	:deep(.vdp-datepicker__calendar) {
		padding: 0px;
		margin: 0px;
		background-color: rgb(200, 198, 198, 1);
	}

	:deep(.vdp-datepicker__calendar header) {
		background-color: transparent;
		font-size: 1.5rem;
		font-weight: 600;
	}

	/*:deep(.vdp-datepicker__calendar .cell) {
	background-color: transparent;
	}

	:deep(.vdp-datepicker__calendar .cell:hover) {
	background-color: #e0e7ff;
	}

	:deep(.vdp-datepicker__calendar .today) {
	border: 1px solid #3f51b5;
	} */

	:deep(.vdp-datepicker__calendar .selected) {
		background-color: var(--save-btn);
		color: white;
	}

	:deep(.vdp-datepicker__calendar .month) {
		background-color: transparent;
		font-size: 1.15rem;
		font-weight: 600;
	}

	:deep(.vdp-datepicker__calendar .month:hover) {
		background-color: var(--save-btn) !important;
	}

	:deep(.vdp-datepicker__calendar .month:focus) {
		background-color: var(--save-btn) !important;
	}

	:deep(.vdp-datepicker__calendar .month.selected) {
		background-color: var(--save-btn) !important;
		color: #fff;
	}

	:deep(.vdp-datepicker__calendar .year) {
		background-color: transparent;
		font-size: 1.15rem;
		font-weight: 600;
	}

	:deep(.vdp-datepicker__calendar .year:hover) {
		background-color: var(--save-btn) !important;
	}

	:deep(.vdp-datepicker__calendar .year:focus) {
		background-color: var(--save-btn) !important;
	}

	:deep(.vdp-datepicker__calendar .year.selected) {
		background-color: var(--save-btn) !important;
		color: #fff;
	}

	.tituloMes {
		display: flex;
		justify-content: center;
		align-items: center;
		border-color: white;
		border-width: 1px;
		border-style: outset;
		z-index: 0;
		font-size: 1.7rem;
		cursor: pointer;
	}

	@media (max-width: 720px) {
		.tituloMes {
			font-size: 1.6rem;
		}
	}

	@media (max-width: 370px) {
		.tituloMes {
			font-size: 1.4rem;
		}
	}

	@media (max-width: 325px) {
		.tituloMes {
			font-size: 1.2rem;
		}
	}

	@media (max-width: 310px) {
		.tituloMes {
			font-size: 1rem;
		}
	}

	.modal-div {
		padding: 16px;
		border-radius: 4px;
		background-color: rgb(200, 198, 198, 1);
		border: solid 1px rgb(102, 101, 101);
		justify-items: center;
		height: max-content;
	}
</style>